import img from '@/assets/images/img/tamga.png';

export const TAMGA_CONFIG = {
  name: 'Tamga',
  browserTitle: 'Tamga',
  info: 'Tamga DLP',
  copyright: 'Copyright (c)',
  right: 'ТОО "Tamga Software"',
  details: null,
  img,
  productName: 'Tamga',
  hiddenRoutes: ['updatesProgram'],
};
